export const DEFAULT_LOCALE = "en";
export const DEFAULT_COUNTRY_CODE = "FR";
export const DEFAULT_USER_COLOR = "#A32A2A";

// DATES FORMATS
export const FORMAT_TYPE_Year_Month_Day = "yyyy-MM-DD";
export const FORMAT_TYPE_Year = "YYYY";

export const REGISTRATION_MODES = {
  PHYSICIANS_AND_PHARMACISTS: "PHYSICIANS_AND_PHARMACISTS",
  PHYSICIANS: "PHYSICIANS",
};

export const PROFILE_TYPES = {
  PHARMACIST: "PHARMACIST",
  DOCTOR: "DOCTOR",
};

export const CONTACT_TYPES = {
  type1: "EMAIL",
  type2: "SMS",
};

export const FORM_TITLES_VARIANTS = [
  {
    label: "sir",
    value: "MR",
  },
  {
    label: "mrs",
    value: "MRS",
  },
  {
    label: "doctorPreffix",
    value: "DR",
  },
  {
    label: "professorPreffix",
    value: "PR",
  },
];

export const ERROR_ANSWERS = {
  SERVICE_EXISTS: "SERVICE_EXISTS",
  SERVICE_EXTERNAL_ID_EXISTS: "SERVICE_EXTERNAL_ID_EXISTS",
};

export const CHECK_USER_ANSWERS = {
  USER_EXISTS: "USER_EXISTS",
  USER_EXTERNAL_ID_EXISTS: "USER_EXTERNAL_ID_EXISTS",
  USER_DOESNT_EXIST: "USER_DOESNT_EXIST",
  MULTIPLE_USERS: "MULTIPLE_USERS",
  SITES_CREATION_NOT_ALLOWED: "SITES_CREATION_NOT_ALLOWED",
};
